import config from "../../config";

let { createSaleClientRoot } = config;

export default {
    PM_COVERAGE_TYPE: `${createSaleClientRoot}/pm-coverage-type`,
    PM_WARRANTY_MULTIPLE_PROPERTIES: `${createSaleClientRoot}/pm-multiple-properties`,
	PM_WARRANTY_PROPERTY_ADDRESS: `${createSaleClientRoot}/pm-property-address`,
    PM_DETAILS: createSaleClientRoot + "/pm-details",
    PM_HOME_OWNER_DETAILS: createSaleClientRoot + "/home-owner-details",
}